import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-links">
          <span onClick={() => navigate("/privacy-policy-impact")}>Privacy Policy</span>
          <span onClick={() => navigate("/terms-and-conditions-impact")}>Terms & Conditions</span>
          <span onClick={() => navigate("/refund-policy-impact")}>Refund Policy</span>
        </div>
        {/* <div className="footer-stats">
          <div>
            <span className="label">Page Update on:</span>
            <span className="value">25/03/2025</span>
          </div>
          <div>
            <span className="label">Visitors:</span>
            <span className="value">9954603</span>
          </div>
        </div> */}
      </div>

      <hr className="footer-divider" />

      <div className="footer-bottom">
        <p>© {currentYear} IMPACT | Powered by <a href="https://100billiontech.com/" target="_blank" rel="noopener noreferrer">100billion Tech</a></p>
        <div className="footer-icons">
          <i className="fa-brands fa-facebook"></i>
          <i className="fa-brands fa-twitter"></i>
          <i className="fa-brands fa-linkedin"></i>
          <i className="fa-brands fa-youtube"></i>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
